import { useState, useEffect, ReactNode } from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';

import { useAppDispatch } from 'hooks/useAppDispatch';
import { getAppConfigThunk } from 'state/settings/settings-thunks';
import { APP_CONFIG_PROFILES } from 'config/app-config';

type Props = {
  children: ReactNode;
};
export const AppConfigProvider = ({ children }: Props) => {
  const dispatch = useAppDispatch();
  const { releaseAppConfig } = useFlags();
  const [isLoading, setIsLoading] = useState<boolean>(releaseAppConfig);

  useEffect(() => {
    if (releaseAppConfig) {
      Promise.allSettled(
        Object.values(APP_CONFIG_PROFILES).map((profile) =>
          dispatch(getAppConfigThunk(profile))
        )
      ).then(() => {
        setIsLoading(false);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isLoading) {
    return null;
  }

  return children;
};
